import React, { useState } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';

function maskTelefone(value) {
  return value
    .replace(/\D/g, '')
    .replace(/^([0-9]{2})([0-9])/, '($1) $2')
    .replace(/([0-9]{5})([0-9])/, '$1-$2')
    .replace(/(-[0-9]{4})[0-9]+?$/, '$1');
}

export default function PrimeiroAcessoFullForm({ onSuccess }) {
  const [formData, setFormData] = useState({
    telefone: '',
    data_nascimento: '',
    password: '',
    password_confirmation: ''
  });
  const [anoInvestidura, setAnoInvestidura] = useState('');
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    if (e.target.name === 'telefone') {
      const masked = maskTelefone(e.target.value);
      setFormData({ ...formData, telefone: masked });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    // Verifica se o usuário é acolito e exige ano_investidura
    const userStored = JSON.parse(localStorage.getItem('user') || '{}');
    const tipoLower = (userStored.tipo || '').toString().toLowerCase();
    const isAcolito = tipoLower === 'acolitos' || tipoLower === 'acolito';

    if (isAcolito) {
      if (!anoInvestidura || !/^\d{4}$/.test(String(anoInvestidura))) {
        setIsSubmitting(false);
        return setError('Informe o ano de investidura válido (ex: 2024).');
      }
    }

    if (!acceptTerms) {
      setIsSubmitting(false);
      return setError('Você deve aceitar os termos de uso para continuar.');
    }
    if (formData.telefone.replace(/\D/g, '').length !== 11 || formData.telefone.length < 15) {
      setIsSubmitting(false);
      return setError('Digite um número de telefone válido no formato (99) 99999-9999.');
    }
    if (formData.password !== formData.password_confirmation) {
      setIsSubmitting(false);
      return setError('As senhas não conferem.');
    }
    if (formData.password.length < 6) {
      setIsSubmitting(false);
      return setError('A senha deve ter no mínimo 6 caracteres.');
    }
    if (!formData.data_nascimento) {
      setIsSubmitting(false);
      return setError('Informe sua data de nascimento.');
    }
    const nascimento = new Date(formData.data_nascimento);
    const hoje = new Date();
    if (nascimento > hoje) {
      setIsSubmitting(false);
      return setError('A data de nascimento não pode ser futura.');
    }
    if (nascimento.getFullYear() === hoje.getFullYear()) {
      setIsSubmitting(false);
      return setError('A data de nascimento não pode ser do ano vigente.');
    }

    try {
      const payload = {
        telefone: formData.telefone,
        data_nascimento: formData.data_nascimento,
        password: formData.password,
        terms_accepted: acceptTerms,
        terms_accepted_at: new Date().toISOString(),
        terms_version: '1.0'
      };
      if (isAcolito) payload.ano_investidura = String(anoInvestidura);

      await api.put('/complete-profile', payload);
      toast.success('Perfil atualizado com sucesso!');
      setTimeout(() => onSuccess && onSuccess(), 1200);
    } catch (err) {
      setError(err.response?.data?.message || 'Ocorreu um erro ao atualizar.');
      toast.error(err.response?.data?.message || 'Ocorreu um erro ao atualizar.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5" aria-label="Formulário de primeiro acesso">
      <div>
        <label htmlFor="telefone" className="block text-sm font-medium text-gray-700">Telefone</label>
        <input
          type="tel"
          name="telefone"
          id="telefone"
          value={formData.telefone}
          onChange={handleChange}
          maxLength={15}
          className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="(99) 99999-9999"
          required
          aria-label="Telefone"
        />
      </div>
      <div>
        <label htmlFor="data_nascimento" className="block text-sm font-medium text-gray-700">Data de Nascimento</label>
        <input
          type="date"
          name="data_nascimento"
          id="data_nascimento"
          value={formData.data_nascimento}
          onChange={handleChange}
          className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          required
          aria-label="Data de Nascimento"
        />
      </div>
      {/* Ano de investidura para acolitos */}
      {(() => {
        const userStored = JSON.parse(localStorage.getItem('user') || '{}');
        const tipoLowerRender = (userStored.tipo || '').toString().toLowerCase();
        const isAcolitoRender = tipoLowerRender === 'acolitos' || tipoLowerRender === 'acolito';
        return isAcolitoRender ? (
          <div>
            <label htmlFor="ano_investidura" className="block text-sm font-medium text-gray-700">Ano de Investidura</label>
            <input
              type="text"
              name="ano_investidura"
              id="ano_investidura"
              value={anoInvestidura}
              onChange={(e) => setAnoInvestidura(e.target.value.replace(/\D/g, ''))}
              maxLength={4}
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="2024"
              required
              aria-label="Ano de Investidura"
            />
          </div>
        ) : null;
      })()}
      <div>
        <label htmlFor="password" className="block text-sm font-medium text-gray-700">Nova Senha</label>
        <input
          type="password"
          name="password"
          id="password"
          value={formData.password}
          onChange={handleChange}
          className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Mínimo de 6 caracteres"
          required
          aria-label="Nova Senha"
        />
      </div>
      <div>
        <label htmlFor="password_confirmation" className="block text-sm font-medium text-gray-700">Confirme a Senha</label>
        <input
          type="password"
          name="password_confirmation"
          id="password_confirmation"
          value={formData.password_confirmation}
          onChange={handleChange}
          className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Repita a nova senha"
          required
          aria-label="Confirme a Senha"
        />
      </div>
      <div className="space-y-3">
        <div className="flex items-start space-x-3">
          <div className="flex items-center h-5 mt-1">
            <input
              id="terms"
              type="checkbox"
              checked={acceptTerms}
              onChange={(e) => setAcceptTerms(e.target.checked)}
              className="h-4 w-4 text-blue-600 border-2 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
              aria-label="Aceitar termos de uso"
            />
          </div>
          <div className="text-sm">
            <label htmlFor="terms" className="text-gray-700 leading-relaxed">
              Ao continuar, você concorda com nossos{' '}
              <button
                type="button"
                onClick={() => setShowTerms(true)}
                className="text-blue-600 hover:text-blue-800 underline font-semibold transition-colors"
                aria-label="Ler termos de uso"
              >
                termos de uso
              </button>
              {' '}e{' '}
              <button
                type="button"
                onClick={() => setShowTerms(true)}
                className="text-blue-600 hover:text-blue-800 underline font-semibold transition-colors"
                aria-label="Ler política de privacidade"
              >
                política de privacidade
              </button>
            </label>
          </div>
        </div>
        {!acceptTerms && (
          <div className="text-xs text-gray-500 ml-7">
            <svg className="inline w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Clique para ler e aceitar os termos
          </div>
        )}
        {acceptTerms && (
          <div className="text-xs text-green-600 ml-7 flex items-center">
            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Termos aceitos
          </div>
        )}
      </div>
      {showTerms && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-60 p-4" aria-modal="true" role="dialog">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[80vh] overflow-hidden">
            <div className="p-6 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold text-gray-900">Termos de Uso e Política de Privacidade</h3>
                <button
                  onClick={() => setShowTerms(false)}
                  className="text-gray-400 hover:text-gray-600"
                  aria-label="Fechar modal de termos"
                >
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
            <div className="p-6 overflow-y-auto max-h-96">
              <div className="prose prose-sm max-w-none">
                <h4 className="text-md font-semibold text-gray-800 mb-3">Termos de Uso</h4>
                <p className="text-gray-600 mb-4">Ao utilizar este sistema de gestão de escalas da paróquia, você concorda em manter as informações atualizadas e usar o sistema de forma responsável.</p>
              </div>
            </div>
            <div className="p-4 border-t border-gray-200 bg-gray-50">
              <div className="flex justify-end space-x-3">
                <button
                  onClick={() => setShowTerms(false)}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                >
                  Fechar
                </button>
                <button
                  onClick={() => { setAcceptTerms(true); setShowTerms(false); }}
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700"
                >
                  Aceitar e Continuar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {error && (
        <div className="text-red-500 text-sm text-center pt-2" aria-live="assertive">{error}</div>
      )}
      <button
        type="submit"
        disabled={!acceptTerms || isSubmitting}
        className={`w-full py-2 px-4 rounded-lg transition duration-300 ${
          acceptTerms && !isSubmitting
            ? 'bg-blue-600 text-white hover:bg-blue-700' 
            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
        }`}
        aria-label="Salvar e Entrar"
      >
        {isSubmitting ? 'Salvando...' : 'Salvar e Entrar'}
      </button>
    </form>
  );
}
